var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5079 45.2113C37.9552 45.2113 44.7622 34.8989 44.7622 25.957C44.7622 25.664 44.7562 25.3725 44.7427 25.0821C46.064 24.127 47.2127 22.9348 48.1186 21.5783C46.9062 22.117 45.6014 22.4797 44.2325 22.6433C45.6296 21.8056 46.7025 20.4798 47.2085 18.8997C45.9008 19.6752 44.4527 20.2386 42.9116 20.5425C41.6763 19.2272 39.9176 18.4045 37.9717 18.4045C34.2342 18.4045 31.2034 21.4353 31.2034 25.171C31.2034 25.7022 31.263 26.2184 31.3785 26.714C25.7547 26.4315 20.7676 23.7384 17.4303 19.644C16.8484 20.6438 16.5134 21.806 16.5134 23.0451C16.5134 25.3927 17.7083 27.4654 19.5251 28.6783C18.415 28.6441 17.3721 28.3388 16.4602 27.8316C16.4587 27.8597 16.4587 27.8882 16.4587 27.9178C16.4587 31.1955 18.7917 33.9318 21.8878 34.5519C21.3194 34.7068 20.7214 34.7901 20.1039 34.7901C19.668 34.7901 19.2441 34.7466 18.8318 34.6682C19.6932 37.3565 22.1916 39.3133 25.1538 39.3684C22.8372 41.1837 19.9194 42.2653 16.749 42.2653C16.2032 42.2653 15.6645 42.2341 15.1348 42.1715C18.1295 44.0907 21.6855 45.2113 25.5079 45.2113Z",
    fill: "#F4F1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1025f35c8ddbfaca082f2536ce33ebbb.svg";
export { ForwardRef as ReactComponent };